const comments = [
  {
    name: '吃瓜一线记者',
    text: '这个平台的爆料速度真的太快了！某顶流密会的消息其他地方还没发，这里已经出完整时间线了。已推荐给所有吃瓜群的朋友，每日必刷！',
    time: '3小时前',
    likes: '2.3k',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20minimal%20avatar%20style%2C%20warm%20crimson%20and%20gold%20circular%20composition%2C%20clean%20modern%20design%2C%20dark%20elegant%20background%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '理性吃瓜人',
    text: '说实话，现在网上假爆料太多了，但吃瓜爆料的审核机制让人放心。每一条都有标注来源和可信度，吃瓜也吃得明明白白。支持这个态度！',
    time: '5小时前',
    likes: '1.8k',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20circular%20avatar%20design%20with%20warm%20amber%20and%20dark%20tones%2C%20geometric%20pattern%2C%20clean%20modern%20aesthetic%2C%20elegant%20composition%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '圈内知情人',
    text: '作为半个圈内人，可以说这里的很多信息准确度相当高。有些甚至是我知道的内部消息，不知道怎么流出来的。总之吃瓜爱好者必关注！',
    time: '8小时前',
    likes: '3.5k',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20circular%20minimal%20avatar%20with%20geometric%20shapes%2C%20deep%20burgundy%20and%20gold%20accents%2C%20clean%20modern%20design%2C%20dark%20elegant%20background%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    name: '暴躁吃瓜群众',
    text: '每天上班第一件事就是打开吃瓜爆料看一眼有什么新瓜！比刷微博还上瘾，而且这里整理得特别清楚，不会像别的地方乱七八糟的。吃瓜爆料每日大赛的投稿越来越精彩了！',
    time: '12小时前',
    likes: '1.2k',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20circular%20minimal%20avatar%20with%20warm%20red%20and%20dark%20geometric%20pattern%2C%20clean%20modern%20aesthetic%2C%20elegant%20composition%2C%20no%20text%20no%20faces&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            网友热评
          </h2>
          <p className="text-sm text-foreground-500">看看吃瓜群众们都怎么说</p>
        </div>

        <div className="space-y-4">
          {comments.map((item, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-50 border border-background-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-semibold text-foreground-800">{item.name}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.text}
                  </p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}